module.exports = __webpack_public_path__ + "files/b850b9c8b7825e35bc515a39db3e1c6d.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/food_drink-1.png
// module id = 511
// module chunks = 76